import PropTypes from 'prop-types';
import { mintSingleton } from 'src/client/mint';
import useOnMount from 'src/common/hooks/useOnMount';

const placementName = 'FreeStarVideoAdContainer';

export default function FreeStarVideoAdContainer({ center = false }) {
  useOnMount(() => {
    let isUnmounting = false;

    async function onMount() {
      if (!mintSingleton.isReady) {
        await mintSingleton.readyPromise;
      }

      if (!isUnmounting) {
        mintSingleton.instance?.requestInContentVideo?.(placementName);
      }
    }

    onMount();

    return async () => {
      isUnmounting = true;

      if (!mintSingleton.isReady) {
        await mintSingleton.readyPromise;
      }

      mintSingleton.instance?.deleteInContentVideo?.(placementName);
    };
  });

  return (
    <div
      id="FreeStarVideoAdContainer"
      style={{ marginTop: '10px', marginBottom: '10px', marginInline: center ? 'auto' : 0 }}
    >
      <div id="freestar-video-parent">
        <div id="freestar-video-child" />
      </div>
    </div>
  );
}

FreeStarVideoAdContainer.propTypes = {
  center: PropTypes.bool,
};
